// extracted by mini-css-extract-plugin
export var divider = "_pp-0";
export var systemMessage = "_pp-1";
export var systemMessageWrapper = "_pp-2";